export default __webpack_public_path__ + "static/fancy_vortex-786421ab4e8bdf25aa4ee62a72520dab.png";